import EditPersonalInformation from './containers/EditPersonalInformation';
import DeleteWorkExperience from './containers/DeleteWorkExperience';
import { AccountTab, AccountTabs, accountTabs } from '../../../config/workspace';
import PersonalInformation from './containers/PersonalInformation';
import AddWorkExperience from './containers/AddWorkExperience';
import WorkExperience from './containers/WorkExperience';
import { useDispatch, useSelector } from '../../../store/store';
import styles from './style.module.scss';
import Education from './containers/Education';
import Expertise from './containers/Expertise';
import AddEducation from './containers/AddEducation';
import Identifying from './containers/Identifying';
import AddExpertise from './containers/AddExpertise';
import { EditIcon, TaskIcon } from '../../../assets/icons/common';
import DeleteEducation from './containers/DeleteEducation';
import UploadedFiles from './containers/UploadedFiles';
import DeleteExpertise from './containers/DeleteExpertise';
import DeleteFile from './containers/DeleteFile';
import { useEffect, useState } from 'react';
import {
    selectAvatarPhoto,
    selectProfileData,
    selectMatchedJobs,
    selectExamsHistory,
    selectUserAttributes,
    selectDeleteFileModal,
    selectAddEducationModal,
    selectAddExpertiseModal,
    selectDeleteEducationModal,
    selectDeleteExpertiseModal,
    selectEditPersonalInfoModal,
    selectAddWorkExperienceModal,
    selectDeleteWorkExperienceModal,
    selectFacePhoto,
} from '../../../store/workspace/selectors';
import { setUploadAvatarModal } from '../../../store/workspace/slice';
import { selectUserId } from '../../../store/auth/selectors';
import { getFacePhotoThunk } from '../../../store/workspace/thunks';
import DropDown from '../../../components/DropDown';

export default function Account() {
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const jobs = useSelector(selectMatchedJobs);
    const avatar = useSelector(selectAvatarPhoto);
    const facePhoto = useSelector(selectFacePhoto);
    const profile = useSelector(selectProfileData);
    const history = useSelector(selectExamsHistory);
    const [tab, setTab] = useState<AccountTab>('Personal');
    const codingExams = history.filter(i => i.status === 'codingExam');
    const interviewList = history.filter(i => i.status === 'interview');
    const userAttributes = useSelector(selectUserAttributes);
    const editPersonalInfoModal = useSelector(selectEditPersonalInfoModal);
    const addWorkExperienceModal = useSelector(selectAddWorkExperienceModal);
    const addEducationModal = useSelector(selectAddEducationModal);
    const addExpertiseModal = useSelector(selectAddExpertiseModal);
    const deleteWorkExperienceModal = useSelector(selectDeleteWorkExperienceModal);
    const deleteEducationModal = useSelector(selectDeleteEducationModal);
    const deleteExpertiseModal = useSelector(selectDeleteExpertiseModal);
    const deleteFileModal = useSelector(selectDeleteFileModal);

    useEffect(() => {
        if (!facePhoto && userId) {
            dispatch(getFacePhotoThunk(`${userId}/face.png`));
        }
    }, [userId]);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.header_img}>
                    {avatar ? <img src={avatar || ''} alt='avatar' /> :
                        <span>{userAttributes?.given_name?.slice(0, 1)}</span>}
                    <div
                        className={styles.header_img_edit}
                        onClick={() => dispatch(setUploadAvatarModal(true))}
                    >
                        <EditIcon width={35} height={35} />
                    </div>
                </div>
                <div className={styles.header_text}>
                    {userAttributes && <span className={styles.header_text_first_name}>
                        {`${userAttributes['custom:firstName']} ${userAttributes.family_name}`}
                    </span>}
                    <span className={styles.header_text_expertise}>
                        {profile && profile.experties.length > 0 && profile.experties[0].expert.title}
                    </span>
                </div>
            </div>
            <div className={styles.exams_data}>
                <div className={styles.exams_data_card}>
                    <span className={styles.exams_data_card_title}>Multiple choice</span>
                    <span className={styles.exams_data_card_detail}><b>{jobs.length}</b> Exam taken</span>
                </div>
                <div className={styles.exams_data_card}>
                    <span className={styles.exams_data_card_title}>Coding</span>
                    <span className={styles.exams_data_card_detail}><b>{codingExams.length}</b> Exam taken</span>
                </div>
                <div className={styles.exams_data_card}>
                    <span className={styles.exams_data_card_title}>Interview</span>
                    <span className={styles.exams_data_card_detail}><b>{interviewList.length}</b> Exam taken</span>
                </div>
            </div>
            <div className={styles.body}>
                <div className={styles.tab}>
                    {accountTabs.map(i => <div
                        className={styles.tab_item}
                        onClick={() => setTab(i.id)}
                        data-is-active={tab === i.id}
                    >
                        <span>{i.title}</span>
                    </div>)}
                </div>

                <div className={styles.body_content}>
                    <DropDown
                        idKey='id'
                        titleKey='title'
                        dropDownList={accountTabs}
                        containerClassName={styles.tab_dropdown}
                        setItem={(item: AccountTabs) => setTab(item.id)}
                        selectedItem={accountTabs.find(item => item.id === tab)}
                    />
                    {tab === 'Identify' && <Identifying facePhoto={facePhoto} kycStatus={profile?.kyc || ''} />}
                    {tab === 'Expertise' && <Expertise data={profile?.experties} />}
                    {tab === 'Education' && <Education data={profile?.educationInfo} />}
                    {tab === 'WorkExperience' && <WorkExperience data={profile?.workExperience} />}

                    {tab === 'Personal' && <PersonalInformation
                        data={userAttributes}
                        salary={profile?.desiredAnnualSalaryRange}
                        visaStatus={profile?.requireSponsorshipVisa}
                    />}

                    {tab === 'Files' && <UploadedFiles
                        resumeFileKey={profile?.resumeFileKey}
                        certificateFileKey={profile?.certificateFileKey}
                        coverLetterFileKey={profile?.coverLetterFileKey}
                        portfolioFileKey={profile?.portfolioFileKey}
                    />}
                </div>
            </div>
            {editPersonalInfoModal && <EditPersonalInformation />}
            {addWorkExperienceModal && <AddWorkExperience />}
            {addEducationModal && <AddEducation />}
            {addExpertiseModal && <AddExpertise />}
            {deleteFileModal && <DeleteFile />}
            {deleteExpertiseModal && <DeleteExpertise />}
            {deleteEducationModal && <DeleteEducation />}
            {deleteWorkExperienceModal && <DeleteWorkExperience />}
        </div>
    );
};
